import type { ListId } from '@vlabs/api/luna-api/model';
import { useParams } from 'react-router-dom';

interface ListIdPathParams {
  listId: ListId;
}

function useListIdFromLocation(): ListId {
  const { listId } = useParams<ListIdPathParams>();

  return listId;
}

export { useListIdFromLocation };
